import { combineReducers } from "redux";
import userinformation from "../features/admin/banknsfc/userinformation/Slice";




const banknsfc = combineReducers({
   userinformation: userinformation,
  
  });
  
  export default banknsfc;